/* ════════════════════════════════════════════
   Nude Project Theme — Core JavaScript (theme.js)
   ════════════════════════════════════════════ */

(function() {
  'use strict';

  // ─── UTILITY FUNCTIONS ───
  const Theme = {
    debounce: function(fn, ms) {
      let timer;
      return function() {
        clearTimeout(timer);
        const args = arguments;
        const context = this;
        timer = setTimeout(function() { fn.apply(context, args); }, ms);
      };
    },

    throttle: function(fn, ms) {
      let lastCall = 0;
      return function() {
        const now = Date.now();
        if (now - lastCall >= ms) {
          lastCall = now;
          fn.apply(this, arguments);
        }
      };
    },

    formatMoney: function(cents, format) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      var value = '';
      var formatString = format || window.theme.moneyFormat || '${{amount}}';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';
        precision = precision == null ? 2 : precision;

        if (isNaN(number) || number == null) return 0;

        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    },

    fetchJSON: function(url, options) {
      options = options || {};
      options.headers = Object.assign({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }, options.headers || {});

      return fetch(url, options).then(function(response) {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      });
    },

    getLocalStorage: function(key) {
      try {
        return JSON.parse(localStorage.getItem(key));
      } catch(e) {
        return null;
      }
    },

    setLocalStorage: function(key, value) {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch(e) {}
    },

    trapFocus: function(element) {
      var focusableElements = element.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
      );
      if (focusableElements.length === 0) return;

      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];

      function handleTab(e) {
        if (e.key !== 'Tab') return;
        if (e.shiftKey) {
          if (document.activeElement === firstFocusable) {
            lastFocusable.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastFocusable) {
            firstFocusable.focus();
            e.preventDefault();
          }
        }
      }

      element.addEventListener('keydown', handleTab);
      firstFocusable.focus();
      element._trapFocusHandler = handleTab;
    },

    removeTrapFocus: function(element) {
      if (element._trapFocusHandler) {
        element.removeEventListener('keydown', element._trapFocusHandler);
      }
    },

    lockBodyScroll: function() {
      document.body.classList.add('no-scroll');
    },

    unlockBodyScroll: function() {
      document.body.classList.remove('no-scroll');
    }
  };

  // ─── CART MANAGER ───
  Theme.Cart = {
    getCart: function() {
      return Theme.fetchJSON('/cart.js');
    },

    addItem: function(variantId, quantity, properties) {
      return Theme.fetchJSON('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({
          id: variantId,
          quantity: quantity || 1,
          properties: properties || {}
        })
      }).then(function(data) {
        Theme.Cart.dispatchUpdate();
        return data;
      });
    },

    updateItem: function(key, quantity) {
      return Theme.fetchJSON('/cart/change.js', {
        method: 'POST',
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function(cart) {
        Theme.Cart.dispatchUpdate(cart);
        return cart;
      });
    },

    removeItem: function(key) {
      return Theme.Cart.updateItem(key, 0);
    },

    clearCart: function() {
      return Theme.fetchJSON('/cart/clear.js', {
        method: 'POST'
      }).then(function(cart) {
        Theme.Cart.dispatchUpdate(cart);
        return cart;
      });
    },

    dispatchUpdate: function(cart) {
      if (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        Theme.Cart.updateUI(cart);
      } else {
        Theme.Cart.getCart().then(function(c) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c } }));
          Theme.Cart.updateUI(c);
        });
      }
    },

    updateUI: function(cart) {
      // Update count badges
      var counts = document.querySelectorAll('[data-cart-count-bubble]');
      counts.forEach(function(el) {
        el.textContent = cart.item_count;
        el.classList.toggle('is-hidden', cart.item_count === 0);
        el.classList.add('bounce');
        setTimeout(function() { el.classList.remove('bounce'); }, 400);
      });

      // Update drawer count
      var drawerCount = document.querySelector('[data-cart-drawer-count]');
      if (drawerCount) drawerCount.textContent = cart.item_count;

      // Update total
      var drawerTotal = document.querySelector('[data-cart-drawer-total]');
      if (drawerTotal) drawerTotal.textContent = Theme.formatMoney(cart.total_price);

      // Refresh cart drawer content using Section Rendering API
      fetch(window.location.pathname + '?sections=cart-drawer')
        .then(res => res.json())
        .then(data => {
          const html = data['cart-drawer'];
          if (!html) return;
          
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newBody = doc.querySelector('[data-cart-drawer-body]');
          const newFooter = doc.querySelector('[data-cart-drawer-footer]');
          
          const currentBody = document.querySelector('[data-cart-drawer-body]');
          const currentFooter = document.querySelector('[data-cart-drawer-footer]');
          
          if (newBody && currentBody) currentBody.innerHTML = newBody.innerHTML;
          if (newFooter && currentFooter) currentFooter.innerHTML = newFooter.innerHTML;
          
          // Re-initialize any logic inside the drawer if needed
          document.dispatchEvent(new CustomEvent('cart:drawer:refreshed'));
        });

      // Update body attribute
      document.body.setAttribute('data-cart-count', cart.item_count);
    }
  };

  // ─── RECENTLY VIEWED ───
  Theme.RecentlyViewed = {
    key: 'nude-recently-viewed',
    maxItems: 8,

    add: function(product) {
      var items = Theme.getLocalStorage(this.key) || [];
      items = items.filter(function(p) { return p.id !== product.id; });
      items.unshift(product);
      if (items.length > this.maxItems) items = items.slice(0, this.maxItems);
      Theme.setLocalStorage(this.key, items);
    },

    get: function() {
      return Theme.getLocalStorage(this.key) || [];
    }
  };

  // ─── WISHLIST ───
  Theme.Wishlist = {
    key: 'nude-wishlist',

    add: function(productId) {
      var list = this.getAll();
      if (list.indexOf(productId) === -1) {
        list.push(productId);
        Theme.setLocalStorage(this.key, list);
        document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
      }
    },

    remove: function(productId) {
      var list = this.getAll().filter(function(id) { return id !== productId; });
      Theme.setLocalStorage(this.key, list);
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
    },

    toggle: function(productId) {
      if (this.isWishlisted(productId)) {
        this.remove(productId);
      } else {
        this.add(productId);
      }
    },

    isWishlisted: function(productId) {
      return this.getAll().indexOf(productId) !== -1;
    },

    getAll: function() {
      return Theme.getLocalStorage(this.key) || [];
    }
  };

  // ─── INITIALIZATION ───
  document.addEventListener('DOMContentLoaded', function() {
    // Cart drawer toggle
    var cartToggle = document.querySelectorAll('[data-cart-toggle]');
    var cartDrawer = document.querySelector('[data-cart-drawer]');
    var cartCloseButtons = document.querySelectorAll('[data-cart-drawer-close]');
    var overlay = document.querySelector('[data-overlay]');

    function openCartDrawer() {
      if (!cartDrawer) return;
      cartDrawer.classList.add('is-active');
      cartDrawer.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-active');
      var header = document.getElementById('site-header');
      if (header) header.classList.add('is-active');
      Theme.lockBodyScroll();
      Theme.trapFocus(cartDrawer);
      document.dispatchEvent(new CustomEvent('cart:drawer:open'));
    }

    function closeCartDrawer() {
      if (!cartDrawer) return;
      cartDrawer.classList.remove('is-active');
      cartDrawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-active');
      var header = document.getElementById('site-header');
      if (header && window.scrollY <= 40 && !header.classList.contains('header--relative')) {
        header.classList.remove('is-active');
      }
      Theme.unlockBodyScroll();
      Theme.removeTrapFocus(cartDrawer);
      document.dispatchEvent(new CustomEvent('cart:drawer:close'));
    }

    cartToggle.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        openCartDrawer();
      });
    });

    cartCloseButtons.forEach(function(btn) {
      btn.addEventListener('click', closeCartDrawer);
    });

    // Open cart drawer on item added
    document.addEventListener('product:added', openCartDrawer);

    // Wishlist initialization (handled exclusively by wishlist.js)
    /*
    var wishlistButtons = document.querySelectorAll('[data-wishlist-toggle]');
    wishlistButtons.forEach(function(btn) {
      var productId = btn.getAttribute('data-wishlist-toggle');
      if (Theme.Wishlist.isWishlisted(productId)) {
        btn.classList.add('is-wishlisted');
      }
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        Theme.Wishlist.toggle(productId);
        btn.classList.toggle('is-wishlisted');
      });
    });
    */

    // Global accordion
    document.querySelectorAll('[data-toggle-accordion]').forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var target = document.getElementById(toggle.getAttribute('data-toggle-accordion'));
        if (target) {
          var isOpen = target.classList.contains('is-open');
          target.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', !isOpen);
        }
      });
    });

    // Global Header Scroll Management (toggles .is-scrolled when scrolling past 40px)
    var globalHeader = document.getElementById('site-header');
    if (globalHeader) {
      var handleGlobalScroll = function() {
        globalHeader.classList.toggle('is-scrolled', window.scrollY > 40);
      };
      window.addEventListener('scroll', handleGlobalScroll, { passive: true });
      handleGlobalScroll(); // Run initially
    }

    // Reduced motion check
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.documentElement.classList.add('reduce-motion');
    }
  });

  // Expose Theme globally
  window.Theme = Theme;

})();
